import React from 'react'
import IntroSections from '../IntroSections'
import './about.css'
import S1_about from './S1_about'
import S2_about from './S2_about'
import S3_about from './S3_about'
import S1_Fotter from '../fotter/S1_Fotter'
const Apout = () => {
  return (
    <>
      <IntroSections sectionName="Apout Us" sectionLink="Apout Us" />
      <S1_about/>
      <S2_about/>   
      <S3_about/>
      <S1_Fotter/>
    </>
  )
}

export default Apout